import AccountingCenterOutlet from './AccountingCenterOutlet';

export default AccountingCenterOutlet;
